<div class="panel-heading headering" [ngStyle]="{ 'background-color': color }">
  <h2 class="modal-title">{{ title }}</h2>
  <button *ngIf="showClose" type="button" class="close" (click)="close.emit()">&times;</button>
</div>
